import React, { Component } from 'react';

export default class Andre extends Component {
  render() {
    return (
      <>
        <h1>It's..... Andre Aggalut!</h1>
        <h1>Music Lover | Quote Appreciator</h1>
        <ul>
          <li>Interests, Curiosities, Motivations & Passions</li>
          <li>Listening to music</li>
          <li>Travel the world one place at a time</li>
          <li>Sports (lots of basketball and football, but anything really)</li>
          <li>
            I enjoy learning new things everyday. Open to any discussions.
          </li>
          <li>Quirk: Daydreams a lot, but we still love them!</li>

          <img src="/img/andre1.svg" alt="" />
          <img src="/img/andre2.svg" alt="" />
          <img src="/img/andre3.svg" alt="" />
          <img src="/img/andre4.svg" alt="" />
        </ul>
      </>
    );
  }
}
